// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"44d05237","581":"327392b4"}[chunkId] + ".chunk.js");